import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {ExecutionsTable} from "../tables/ExecutionsTable.tsx";

export const IndexPage = () => {
    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <ExecutionsTable/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
